<template>
  <div class="content-body">
    <div class="xinxi">
      <div class="title">
        基础信息
      </div>
      <div class="line-list">
        <div class="left-title">登录名：{{ user_info.user_name }}</div>
        <div class="right-title">公司官网：{{ user_info.company_link }}</div>
      </div>
      <div class="line-list">
        <div class="left-title">联系人：{{ user_info.contact_name }}</div>
        <div class="right-title">公司邮箱：{{ user_info.company_mail }}</div>
      </div>
      <div class="line-list">
        <div class="left-title">公司名称：{{ user_info.company_name }}</div>
        <div class="right-title">手机号：{{ user_info.contact_mobile }}</div>
      </div>
      <div class="line-list">
        <div class="left-title">所属行业：{{ user_info.company_type }}</div>
        <div class="right-title">通讯地址：{{ user_info.address }}</div>
      </div>
      <div class="line-list">
        <div class="right-title">营业执照号：{{ user_info.company_business_no }}</div>
      </div>
    </div>
    <div class="xinxi">
      <div class="title">
        账户资质
      </div>
      <div class="img-lists">
        <!-- <el-image style="width: 250px; margin-right: 15px;" :src="getImg(user_info.company_business)" fit="contain"></el-image>
        <el-image style="width: 250px; margin-right: 15px;" :src="getImg(user_info.company_icp)" fit="contain"></el-image>
        <el-image style="width: 250px; margin-right: 15px;" :src="getImg(user_info.company_intel)" fit="contain"></el-image> -->
        <div>
          <img :src="getImg(user_info.company_business)" alt="jpg" style="width: 250px; height: 300px; object-fit: contain;">
        </div>
        <div>
          <img :src="getImg(user_info.company_icp)" alt="jpg" style="width: 250px; height: 300px; object-fit: contain;">
        </div>
        <div>
          <img :src="getImg(user_info.company_intel)" alt="jpg" style="width: 250px; height: 300px; object-fit: contain;">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user_info: []
    };
  },
  mounted() {
    this.user_info = JSON.parse(sessionStorage.getItem('user_info'));
    setTimeout(() => {
      this.$function.hiddenLoading();
    }, 200);
  },
  methods: {
    getImg(img) {
      return this.$Config.apiUrl + img;
    }
  }
};
</script>
<style lang="less" scoped>
  .xinxi {
    width: calc(100% - 50px);
    margin-top: 10px;
    background: #fff;
    padding: 25px;
    .title {
      display: flex;
      align-items: center;
      font-size: 18px;
      color: #221815;
      padding: 10px 0;
      img {
        width: 18px;
        height: 18px;
        margin-right: 10px;
      }
    }
    .line-list {
      width: 100%;
      display: flex;
      margin-top: 18px;
      .left-title, .right-title {
        width: 350px;
        font-size: 14px;
        color: #221815;
      }
    }
    .img-lists {
      // display: flex;
      div {
        padding-bottom: 30px;
        margin-top: 10px;
      }
      img {
        width: 250px;
        margin-right: 15px;
      }
    }
  }
</style>
